import { defineStore } from 'pinia';

export const usePageLayoutStore = defineStore('pageLayout', {
    state: () => ({
        loading: false,
        nonDestructiveOnLoading: false,
    }),
    actions: {
        setLoading(loading: boolean) {
            this.loading = loading;
        },
        setNonDestructiveOnLoading(nonDestructiveOnLoading: boolean) {
            this.nonDestructiveOnLoading = nonDestructiveOnLoading;
        },
        resetPageLayout() {
            this.loading = false;
            this.nonDestructiveOnLoading = false;
        },
    },
});
